/** Zgodnie z `js/shared/editors/stream-format-editor.js` + backend. */
export type StreamFormatOption = 'ts_no_live' | 'ts' | 'm3u8';

export function transformUrlPreview(url: string | null | undefined, option: StreamFormatOption): string {
  const u = String(url ?? '');
  if (!u) return u;
  const parts = u.split('?', 2);
  const main = parts[0];
  const query = parts.length === 2 ? `?${parts[1]}` : '';

  const m = main.match(/^(https?:\/\/[^/]+)(\/.*)$/i);
  if (!m) return u;
  const base = m[1];
  let path = m[2];

  const ensureLivePrefix = () => {
    if (path.startsWith('/live/')) return;
    if (path === '/live') {
      path = '/live/';
      return;
    }
    path = `/live${path}`;
  };

  const removeLivePrefix = () => {
    if (path.startsWith('/live/')) path = path.substring('/live'.length);
    else if (path === '/live') path = '/';
  };

  const removeM3u8Ext = () => {
    if (path.toLowerCase().endsWith('.m3u8')) path = path.substring(0, path.length - 5);
  };

  const ensureM3u8Ext = () => {
    path = path.replace(/(\.m3u8)$/i, '');
    path = path.replace(/(\.ts)$/i, '');
    path = path.replace(/(\.mpegts)$/i, '');
    path = path.replace(/(\.m3u)$/i, '');
    path += '.m3u8';
  };

  if (option === 'ts_no_live') {
    removeLivePrefix();
    removeM3u8Ext();
  } else if (option === 'ts') {
    ensureLivePrefix();
    removeM3u8Ext();
  } else if (option === 'm3u8') {
    ensureLivePrefix();
    ensureM3u8Ext();
  }

  return base + path + query;
}
